<template>
<modal @close="$emit('cancel')">
    <template slot="header">
        <span class="warning-text"><i class="material-icons">warning</i></span>
        <strong class="ml-2">Warning</strong>
    </template>

   <template slot="content">
       <div v-html="this.warningMessage()"></div>
    </template>

    <template slot="footer">
        <div class="flex jc-fe">
            <button type="button" @click="$emit('cancel')">No</button>
            <button type="button" class="ml-3" @click="$emit('confirm')">Yes</button>
        </div>
    </template>
</modal>
</template>

<script>
export default {
    name: "send-letter-warning-modal",

    props: {
        isInitialLetter: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        warningMessage () {
            if (this.isInitialLetter) {
                return "Have ineligible tenants been removed? If not, click the <span class='secondary-text'>Remove Ineligible Tenants</span> \n" +
                        "button and apply the <span class='secondary-text'>Audit Letter Ready</span> filter to the updated tenants list before trying again."
            } else {
                return "Have tenant statuses been updated? If not, click the  <span class='secondary-text'>Sync Tenant Statuses</span> \n" +
                        "button and apply the appropriate filter to the updated tenants before trying again."
            }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SendLetterWarningModal.vue